const isWxProgram = () => {
  return new Promise((resolve, reject) => {
    const ua = navigator.userAgent.toLowerCase()
    //ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
    if (ua.includes("micromessenger")) {
      wx.miniProgram.getEnv((res) => {
        res.miniprogram ? resolve(true) : reject(false)
      })
    } else {
      reject(false)
    }
  })
}
export default isWxProgram